import React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import TagIcon from '../assets/images/tag-64x64.svg';
import { __, setTableParams, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import {
  listFiles,
  multipleEditFileTags,
} from '../redux/actions/table/files';
import MultipleFileTagsEditForm from '../forms/wizard_multiple_file_tags_edit/MultipleFileTagsEditForm';
import styles from '../styles/wizards/MultipleTaskTagsEditWizard.scss';

const mapStateToProps = (state) => ({
  file_ids: _.get(state.table, 'files.wizard_multiple_file_tags_edit'),
});

const MultipleFileTagsEditWizard = ({ file_ids, match, onClose }) => {
  const handleSubmit = (formData) =>
    validateForm(
      multipleEditFileTags(
        match.params.stage,
        file_ids,
        _.get(formData, 'tags'),
      ).then(() => {
        listFiles(match.params.stage);

        setTableParams('files', {
          selected_rows: [],
          wizard_multiple_file_tags_edit: undefined,
        });

        setNotification(__('Multiple file tags have been saved.'));

        onClose();
      }),
    );

  return (
    <>
      <div className={styles.header}>
        <div className={styles.left}>
          <span>{__('Multiple Edit File Tags')}</span>
          <span>{__('Choose the tags for selected files')}</span>
        </div>
        <div className={styles.right}>
          <TagIcon />
        </div>
      </div>
      <div className={styles.body}>
        <MultipleFileTagsEditForm
          onSubmit={handleSubmit}
          onClose={onClose}
        />
      </div>
    </>
  );
};

export default withRouter(connect(mapStateToProps)(MultipleFileTagsEditWizard));
